export const API_KEY_CREATE_DRAWER_TEST_ID = "api-key-create-drawer";
